module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w3-main main-container"
  }, [_c('div', {
    staticClass: "thumbnail-row"
  }, [_c('div', {
    staticClass: "header-button-container w3-hide-large"
  }, [_c('button', {
    staticClass: "w3-button",
    on: {
      "click": _vm.showNavbar
    }
  }, [_vm._v("☰")])]), _vm._v(" "), _vm._l((_vm.templates), function(template) {
    return _c('div', {
      staticClass: "thumbnail-container",
      class: {
        active: template._id === _vm.activeTemplate._id
      },
      on: {
        "click": function($event) {
          return _vm.pickTemplate(template)
        }
      }
    }, [_c('div', [_c('img', {
      attrs: {
        "src": ("static/templates/" + (template._id) + "/thumbnail.png")
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "template-name-container"
    }, [_vm._v(_vm._s(template.name[_vm.locale]))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "constructor-container"
  }, [_c('div', {
    staticClass: "samples-container"
  }, [_c('div', {
    staticClass: "sample"
  }, [_vm._v(_vm._s(_vm.$t('Samples')))]), _vm._v(" "), _c('div', {
    staticClass: "sample-images-container"
  }, _vm._l((_vm.activeTemplate.samples), function(sample) {
    return _c('div', {
      staticClass: "sample-row",
      on: {
        "click": function($event) {
          return _vm.pickSample(sample)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": ("static/templates/" + (_vm.activeTemplate._id) + "/sample-thumbnails/" + sample)
      }
    }), _vm._v(" "), _c('div', [_vm._v(_vm._s(sample.split('.').shift()))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "layer-container"
  }, [_c('img', {
    attrs: {
      "src": ("static/templates/" + (_vm.activeTemplate._id) + "/samples/" + _vm.pickedSample)
    }
  }), _vm._v(" "), _vm._l((_vm.activeTemplate.layers), function(layer) {
    return _c('img', {
      attrs: {
        "src": ("static/templates/" + (_vm.activeTemplate._id) + "/layers/" + layer)
      }
    })
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a46d1106","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Constructor.vue
// module id = 953
// module chunks = 0